/**
 * Cadastro das campanhas exibidas no banner que aparece assim que o cliente faz login.
 *
 * COMO ATIVAR UMA NOVA CAMPANHA (sem precisar mexer em nenhum outro arquivo do projeto):
 *   1. Coloque as imagens do banner (versão desktop e versão mobile) dentro de uma nova
 *      pasta em `src/assets/img/<nome-da-campanha>/`.
 *   2. Importe as duas imagens no topo deste arquivo (veja o exemplo da "copa-2026" abaixo).
 *   3. Adicione um novo objeto ao array `campaigns`, definindo `startDate` e `endDate`
 *      com o período em que o banner deve ficar visível.
 *   4. Pronto. O banner aparece sozinho automaticamente dentro do período configurado
 *      e some sozinho quando a data final passar — não precisa remover nada depois.
 *
 * Formato das datas: 'AAAA-MM-DDTHH:mm:ss' (horário local de Brasília).
 *   Exemplo: '2026-08-01T00:00:00' até '2026-08-31T23:59:59'.
 *
 * Se mais de uma campanha estiver com o período ativo ao mesmo tempo, vale a primeira
 * encontrada na lista (de cima para baixo).
 */

import bannerCanecaDesktop from '../assets/img/caneca-outubro-2026/AcordeOn-BannerCaneca.jpeg';
import bannerCanecaMobile from '../assets/img/caneca-outubro-2026/AcordeOn-BannerVerticalCaneca.jpeg';

const campaigns = [
  {
    id: 'caneca-2026',
    startDate: '2026-10-01T00:00:00',
    endDate: '2026-10-31T23:59:59',
    bannerDesktop: bannerCanecaDesktop,
    bannerMobile: bannerCanecaMobile,
    alt: 'Campanha Caneca AcordeOn - Outubro de 2026',
    link: null,
  },
];

export function getActiveCampaign(referenceDate = new Date()) {
  return campaigns.find(campaign => {
    const start = new Date(campaign.startDate);
    const end = new Date(campaign.endDate);

    return referenceDate >= start && referenceDate <= end;
  });
}

export default campaigns;
